<template>
    <div class="pb-5">
        <data-table ref="contracts"
                    :api-route="backendApiRoute"
                    :api-view-set="contractTable.apiViewSet"
                    :name="contractTable.name"
                    :columns="contractTable.columns"
                    :search="contractTable.search"
                    :filters="contractTable.filters ? contractTable.filters : []"
                    :actions="contractTable.actions"
                    :orderings="contractTable.orderings"
                    :initial-orderings="contractTable.initialOrderings"
                    :row-actions="contractTable.rowActions"
                    :key="contractTable.key">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import {Request} from "@/pages/AppPages/Requests/request";
import {Contract} from "@/pages/AppPages/Catalogs/Contracts/contract";

export default {
    name: "ContractList",
        components: { DataTable },
        computed: {
            ...mapGetters(['ability', 'isInController']),
            backendApiRoute() { return api.contracts.default.list() },
        },
        data() {

            return {
                contractTable: {
                    name: 'contracts-table',
                    apiViewSet: api.contracts.default,
                    key: 'contracts-table',
                    search: true,
                    columns: [
                        {
                            name: 'number',
                            title:  'Номер',
                            alwaysVisible: true,
                            to: {
                                idColumn: 'id',
                                routeName: 'contractDetail',
                                prependWithN: true
                            },
                            extraDataFrom: 'type_name'
                        },
                        { name: 'currently_valid', 'title': 'Действителен',
                            cellComponentName: 'BooleanCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                        { name: 'customer_object.name', title: 'Заказчик' },
                        { name: 'contractor_object.name', title: 'Исполнитель' },
                        { name: 'valid_from', title: 'Дата начала',
                            cellComponentName: 'DateTimeCell', cellComponentPath: 'src/pages/DataTableCells/' },
                        { name: 'valid_until', title: 'Дата окончания',
                            cellComponentName: 'DateTimeCell', cellComponentPath: 'src/pages/DataTableCells/' },
                        { name: 'price', title: 'Стоимость' },
                        { name: 'animals_limit', title: 'Количество животных' },
                    ],
                    orderings: [
                        'number', 'valid_from', 'valid_until',
                        { 'contractor_object.name': 'contractor__name' },
                        { 'customer_object.name': 'customer__name' }
                    ],
                    actions: [],
                    rowActions: [],
                    filters: [
                        { title: 'Действует', name: 'is_valid', type: 'boolean'  },
                        { title: 'Действовал', name: 'valid_date', type: 'dateFromTo' },
                    ]
                }
            }
        },
    mounted() {
        this.contractTable.actions.push(
            actions.create(() => {
                    this.$router.push({name: 'contractCreate'})
                }, this.ability.can('create', 'Contract')
            )
        );

        if (this.ability.can('destroy', 'Contract')) {
            this.contractTable.rowActions.push(
                new actions.objectDelete(Contract))
        }

        this.contractTable.filters.push({
            title: 'Тип контракта',
            name: 'contract_type',
            source: api.contracts.types.list(),
        })
        // PETS-292: убрали ограничение по контролеру
        if (this.isInController) {
            this.contractTable.filters.push({
                title: 'Исполнитель',
                name: 'contractor',
                source: api.requests.contractors.list(),
                hasSearch: true
            });
        }
        this.contractTable.filters.push({
            title: 'Заказчик',
            name: 'customer',
            source: api.requests.customers.list(),
            hasSearch: true
        });

        // }

    }
}
</script>

<style scoped>

</style>